const useEventIdStorage = () => {
    const key = "eventid";

    const saveEventId = eventid => {
        localStorage.setItem(key, eventid);
    }

    const getEventId = () => {
        return localStorage.getItem(key);
    }

    const removeEventid = () => {
        localStorage.removeItem(key);
    }

    return {
        saveEventId,
        getEventId,
        removeEventid
    }
}

export default useEventIdStorage;